<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <h3 class="mb-5">Nustatymo informacija</h3>

    <template v-if="!showNustatymas && !pageloading">
      <el-button primary @click.native="gotoHipotekaPranesimas()"
        >Pasirinkite veiksmą "Sudarymas"</el-button
      >
    </template>
    <template v-if="showNustatymas">
      <div class="dataContainer">
        <v-row>
          <v-col cols="12">
            <el-textarea
              label="Kitos sąlygos"
              tooltip="Hipoteka. Nustatymas. Kitos sąlygos"
              :counter="4000"
              :readonly="isReadonlyForm"
              v-model="formData.obj_nustatymas_kitos_salygos"
            />
          </v-col>
        </v-row>
      </div>
      <hipoteka-istorija duomenys="sandoris" />

      <v-footer class="form-footer">
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="saveData()"
          :loading="loading"
          >Saugoti</el-button
        >
        <el-button
          v-if="!isReadonlyForm"
          @click.native="cancelData()"
          :loading="loading"
          >Atšaukti</el-button
        >

        <v-spacer></v-spacer>
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="checkErrorsClick()"
          :loading="loading"
          >Tikrinti</el-button
        >
      </v-footer>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'

export default {
  name: 'HipotekaNustatymas',
  components: {
    HipotekaIstorija,
  },
  mixins: [unsavedData, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      loading: true,
      pageloading: true,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    showNustatymas() {
      return this.formData.obj_veiksmas === 1
    },
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/nustatymoinformacija`)
        .then(res => {
          this.formData = res.data.nustatymo_informacija
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.obj_id = this.objektasID

          this.$axios
            .post(`objektas/${this.objektasID}/nustatymoinformacija`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.getData()
    },

    gotoHipotekaPranesimas() {
      this.$router.push({
        name: 'hipotekaPranesimas',
        params: {
          objektasID: this.objektasID,
        },
      })
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
